import NavBar from "@/components/navigation/NavBar";
import Footer from "@/components/navigation/Footer";
import React from "react";

export default function Datenschutz() {
  return (
    <div>
        <NavBar className=" bg-white/100" />
    <div className=" pt-20  bg-gray-50">
    <div className="flex flex-col  justify-center max-w-6xl mx-auto w-full h-full p-10  text-dark-200">
      <h1>Datenschutz&shy;erkl&auml;rung</h1>
      <h2>1. Datenschutz auf einen Blick</h2>
      <h3>Allgemeine Hinweise</h3>{" "}
      <p>
        Die folgenden Hinweise geben einen einfachen &Uuml;berblick
        dar&uuml;ber, was mit Ihren personenbezogenen Daten passiert, wenn Sie
        diese Website besuchen. Personenbezogene Daten sind alle Daten, mit
        denen Sie pers&ouml;nlich identifiziert werden k&ouml;nnen.
        Ausf&uuml;hrliche Informationen zum Thema Datenschutz entnehmen Sie
        unserer unter diesem Text aufgef&uuml;hrten Datenschutzerkl&auml;rung.
      </p>
      <h3>Datenerfassung auf dieser Website</h3>{" "}
      <h4>
        Wer ist verantwortlich f&uuml;r die Datenerfassung auf dieser Website?
      </h4>{" "}
      <p>
        Die Datenverarbeitung auf dieser Website erfolgt durch den
        Websitebetreiber. Dessen Kontaktdaten k&ouml;nnen Sie dem Abschnitt
        &bdquo;Hinweis zur Verantwortlichen Stelle&ldquo; in dieser
        Datenschutzerkl&auml;rung entnehmen.
      </p>{" "}
      <h4>Wie erfassen wir Ihre Daten?</h4>{" "}
      <p>
        Ihre Daten werden zum einen dadurch erhoben, dass Sie uns diese
        mitteilen. Hierbei kann es sich z.&nbsp;B. um Daten handeln, die Sie in
        ein Kontaktformular eingeben.
      </p>{" "}
      <p>
        Andere Daten werden automatisch oder nach Ihrer Einwilligung beim Besuch
        der Website durch unsere IT-Systeme erfasst. Das sind vor allem
        technische Daten (z.&nbsp;B. Internetbrowser, Betriebssystem oder
        Uhrzeit des Seitenaufrufs). Die Erfassung dieser Daten erfolgt
        automatisch, sobald Sie diese Website betreten.
      </p>{" "}
      <h4>Wof&uuml;r nutzen wir Ihre Daten?</h4>{" "}
      <p>
        Ein Teil der Daten wird erhoben, um eine fehlerfreie Bereitstellung der
        Website zu gew&auml;hrleisten. Andere Daten k&ouml;nnen zur Analyse
        Ihres Nutzerverhaltens verwendet werden. Sofern &uuml;ber die Website
        Vertr&auml;ge geschlossen oder angebahnt werden k&ouml;nnen, werden die
        &uuml;bermittelten Daten auch f&uuml;r Vertragsangebote, Bestellungen
        oder sonstige Auftragsanfragen verarbeitet.
      </p>{" "}
      <h4>Welche Rechte haben Sie bez&uuml;glich Ihrer Daten?</h4>{" "}
      <p>
        Sie haben jederzeit das Recht, unentgeltlich Auskunft &uuml;ber
        Herkunft, Empf&auml;nger und Zweck Ihrer gespeicherten personenbezogenen
        Daten zu erhalten. Sie haben au&szlig;erdem ein Recht, die Berichtigung
        oder L&ouml;schung dieser Daten zu verlangen. Wenn Sie eine Einwilligung
        zur Datenverarbeitung erteilt haben, k&ouml;nnen Sie diese Einwilligung
        jederzeit f&uuml;r die Zukunft widerrufen. Au&szlig;erdem haben Sie das
        Recht, unter bestimmten Umst&auml;nden die Einschr&auml;nkung der
        Verarbeitung Ihrer personenbezogenen Daten zu verlangen. Des Weiteren
        steht Ihnen ein Beschwerderecht bei der zust&auml;ndigen
        Aufsichtsbeh&ouml;rde zu.
      </p>{" "}
      <p>
        Hierzu sowie zu weiteren Fragen zum Thema Datenschutz k&ouml;nnen Sie
        sich jederzeit an uns wenden.
      </p>
      <h3>Analyse-Tools und Tools von Dritt&shy;anbietern</h3>{" "}
      <p>
        Beim Besuch dieser Website kann Ihr Surf-Verhalten statistisch
        ausgewertet werden. Das geschieht vor allem mit sogenannten
        Analyseprogrammen.
      </p>{" "}
      <p>
        Detaillierte Informationen zu diesen Analyseprogrammen finden Sie in der
        folgenden Datenschutzerkl&auml;rung.
      </p>
      <h2>2. Hosting</h2>
      <p>Wir hosten die Inhalte unserer Website bei folgendem Anbieter:</p>
      <h3>IONOS</h3>{" "}
      <p>
        Anbieter ist die IONOS SE, Elgendorfer Str. 57, 56410 Montabaur
        (nachfolgend IONOS). Wenn Sie unsere Website besuchen, erfasst IONOS
        verschiedene Logfiles inklusive Ihrer IP-Adressen. Details entnehmen Sie
        der Datenschutzerkl&auml;rung von IONOS:{" "}
        <a
          href="https://www.ionos.de/terms-gtc/terms-privacy"
          target="_blank"
          rel="noopener noreferrer"
        >
          https://www.ionos.de/terms-gtc/terms-privacy
        </a>
        .
      </p>{" "}
      <p>
        Die Verwendung von IONOS erfolgt auf Grundlage von Art. 6 Abs. 1 lit. f
        DSGVO. Wir haben ein berechtigtes Interesse an einer m&ouml;glichst
        zuverl&auml;ssigen Darstellung unserer Website. Sofern eine
        entsprechende Einwilligung abgefragt wurde, erfolgt die Verarbeitung
        ausschlie&szlig;lich auf Grundlage von Art. 6 Abs. 1 lit. a DSGVO und
        &sect; 25 Abs. 1 TDDDG, soweit die Einwilligung die Speicherung von
        Cookies oder den Zugriff auf Informationen im Endger&auml;t des Nutzers
        (z.&nbsp;B. Device-Fingerprinting) im Sinne des TDDDG umfasst. Die
        Einwilligung ist jederzeit widerrufbar.
      </p>
      <h4>Auftragsverarbeitung</h4>{" "}
      <p>
        Wir haben einen Vertrag &uuml;ber Auftragsverarbeitung (AVV) zur Nutzung
        des oben genannten Dienstes geschlossen. Hierbei handelt es sich um
        einen datenschutzrechtlich vorgeschriebenen Vertrag, der
        gew&auml;hrleistet, dass dieser die personenbezogenen Daten unserer
        Websitebesucher nur nach unseren Weisungen und unter Einhaltung der
        DSGVO verarbeitet.
      </p>
      <h2>3. Allgemeine Hinweise und Pflicht&shy;informationen</h2>
      <h3>Datenschutz</h3>{" "}
      <p>
        Die Betreiber dieser Seiten nehmen den Schutz Ihrer pers&ouml;nlichen
        Daten sehr ernst. Wir behandeln Ihre personenbezogenen Daten vertraulich
        und entsprechend den gesetzlichen Datenschutzvorschriften sowie dieser
        Datenschutzerkl&auml;rung.
      </p>{" "}
      <p>
        Wenn Sie diese Website benutzen, werden verschiedene personenbezogene
        Daten erhoben. Personenbezogene Daten sind Daten, mit denen Sie
        pers&ouml;nlich identifiziert werden k&ouml;nnen. Die vorliegende
        Datenschutzerkl&auml;rung erl&auml;utert, welche Daten wir erheben und
        wof&uuml;r wir sie nutzen. Sie erl&auml;utert auch, wie und zu welchem
        Zweck das geschieht.
      </p>{" "}
      <p>
        Wir weisen darauf hin, dass die Daten&uuml;bertragung im Internet
        (z.&nbsp;B. bei der Kommunikation per E-Mail) Sicherheitsl&uuml;cken
        aufweisen kann. Ein l&uuml;ckenloser Schutz der Daten vor dem Zugriff
        durch Dritte ist nicht m&ouml;glich.
      </p>
      <h3>Hinweis zur verantwortlichen Stelle</h3>{" "}
      <p>
        Die verantwortliche Stelle f&uuml;r die Datenverarbeitung auf dieser
        Website ist:
      </p>{" "}
      <p>
        Helga Jakobs Immobilienges. mbH
        <br />
        Uferstra&szlig;e 40
        <br />
        52249 Eschweiler
      </p>
      <p>
        Telefon: 02403 - 883170
        <br />
        E-Mail: info@jakobs-immobilien.de
      </p>
      <p>
        Verantwortliche Stelle ist die nat&uuml;rliche oder juristische Person,
        die allein oder gemeinsam mit anderen &uuml;ber die Zwecke und Mittel
        der Verarbeitung von personenbezogenen Daten (z.&nbsp;B. Namen,
        E-Mail-Adressen o. &Auml;.) entscheidet.
      </p>
      <h3>Speicherdauer</h3>{" "}
      <p>
        Soweit innerhalb dieser Datenschutzerkl&auml;rung keine speziellere
        Speicherdauer genannt wurde, verbleiben Ihre personenbezogenen Daten bei
        uns, bis der Zweck f&uuml;r die Datenverarbeitung entf&auml;llt. Wenn
        Sie ein berechtigtes L&ouml;schersuchen geltend machen oder eine
        Einwilligung zur Datenverarbeitung widerrufen, werden Ihre Daten
        gel&ouml;scht, sofern wir keine anderen rechtlich zul&auml;ssigen
        Gr&uuml;nde f&uuml;r die Speicherung Ihrer personenbezogenen Daten haben
        (z.&nbsp;B. steuer- oder handelsrechtliche Aufbewahrungsfristen); im
        letztgenannten Fall erfolgt die L&ouml;schung nach Fortfall dieser
        Gr&uuml;nde.
      </p>
      <h3>
        Allgemeine Hinweise zu den Rechtsgrundlagen der Datenverarbeitung auf
        dieser Website
      </h3>{" "}
      <p>
        Sofern Sie in die Datenverarbeitung eingewilligt haben, verarbeiten wir
        Ihre personenbezogenen Daten auf Grundlage von Art. 6 Abs. 1 lit. a
        DSGVO bzw. Art. 9 Abs. 2 lit. a DSGVO, sofern besondere Datenkategorien
        nach Art. 9 Abs. 1 DSGVO verarbeitet werden. Im Falle einer
        ausdr&uuml;cklichen Einwilligung in die &Uuml;bertragung
        personenbezogener Daten in Drittstaaten erfolgt die Datenverarbeitung
        au&szlig;erdem auf Grundlage von Art. 49 Abs. 1 lit. a DSGVO. Sofern Sie
        in die Speicherung von Cookies oder in den Zugriff auf Informationen in
        Ihr Endger&auml;t (z.&nbsp;B. via Device-Fingerprinting) eingewilligt
        haben, erfolgt die Datenverarbeitung zus&auml;tzlich auf Grundlage von
        &sect; 25 Abs. 1 TDDDG. Die Einwilligung ist jederzeit widerrufbar. Sind
        Ihre Daten zur Vertragserf&uuml;llung oder zur Durchf&uuml;hrung
        vorvertraglicher Ma&szlig;nahmen erforderlich, verarbeiten wir Ihre
        Daten auf Grundlage des Art. 6 Abs. 1 lit. b DSGVO. Des Weiteren
        verarbeiten wir Ihre Daten, sofern diese zur Erf&uuml;llung einer
        rechtlichen Verpflichtung erforderlich sind auf Grundlage von Art. 6
        Abs. 1 lit. c DSGVO. Die Datenverarbeitung kann ferner auf Grundlage
        unseres berechtigten Interesses nach Art. 6 Abs. 1 lit. f DSGVO
        erfolgen. &Uuml;ber die jeweils im Einzelfall einschl&auml;gigen
        Rechtsgrundlagen wird in den folgenden Abs&auml;tzen dieser
        Datenschutzerkl&auml;rung informiert.
      </p>
      <h3>Empf&auml;nger von personenbezogenen Daten</h3>{" "}
      <p>
        Im Rahmen unserer Gesch&auml;ftst&auml;tigkeit arbeiten wir mit
        verschiedenen externen Stellen zusammen. Dabei ist teilweise auch eine
        &Uuml;bermittlung von personenbezogenen Daten an diese externen Stellen
        erforderlich. Wir geben personenbezogene Daten nur dann an externe
        Stellen weiter, wenn dies im Rahmen einer Vertragserf&uuml;llung
        erforderlich ist, wenn wir gesetzlich hierzu verpflichtet sind
        (z.&nbsp;B. Weitergabe von Daten an Steuerbeh&ouml;rden), wenn wir ein
        berechtigtes Interesse nach Art. 6 Abs. 1 lit. f DSGVO an der Weitergabe
        haben oder wenn eine sonstige Rechtsgrundlage die Datenweitergabe
        erlaubt. Beim Einsatz von Auftragsverarbeitern geben wir
        personenbezogene Daten unserer Kunden nur auf Grundlage eines
        g&uuml;ltigen Vertrags &uuml;ber Auftragsverarbeitung weiter. Im Falle
        einer gemeinsamen Verarbeitung wird ein Vertrag &uuml;ber gemeinsame
        Verarbeitung geschlossen.
      </p>
      <h3>Widerruf Ihrer Einwilligung zur Datenverarbeitung</h3>{" "}
      <p>
        Viele Datenverarbeitungsvorg&auml;nge sind nur mit Ihrer
        ausdr&uuml;cklichen Einwilligung m&ouml;glich. Sie k&ouml;nnen eine
        bereits erteilte Einwilligung jederzeit widerrufen. Die
        Rechtm&auml;&szlig;igkeit der bis zum Widerruf erfolgten
        Datenverarbeitung bleibt vom Widerruf unber&uuml;hrt.
      </p>
      <h3>
        Widerspruchsrecht gegen die Datenerhebung in besonderen F&auml;llen
        sowie gegen Direktwerbung (Art. 21 DSGVO)
      </h3>{" "}
      <p>
        WENN DIE DATENVERARBEITUNG AUF GRUNDLAGE VON ART. 6 ABS. 1 LIT. E ODER F
        DSGVO ERFOLGT, HABEN SIE JEDERZEIT DAS RECHT, AUS GR&Uuml;NDEN, DIE SICH
        AUS IHRER BESONDEREN SITUATION ERGEBEN, GEGEN DIE VERARBEITUNG IHRER
        PERSONENBEZOGENEN DATEN WIDERSPRUCH EINZULEGEN; DIES GILT AUCH F&Uuml;R
        EIN AUF DIESE BESTIMMUNGEN GEST&Uuml;TZTES PROFILING. DIE JEWEILIGE
        RECHTSGRUNDLAGE, AUF DENEN EINE VERARBEITUNG BERUHT, ENTNEHMEN SIE
        DIESER DATENSCHUTZERKL&Auml;RUNG. WENN SIE WIDERSPRUCH EINLEGEN, WERDEN
        WIR IHRE BETROFFENEN PERSONENBEZOGENEN DATEN NICHT MEHR VERARBEITEN, ES
        SEI DENN, WIR K&Ouml;NNEN ZWINGENDE SCHUTZW&Uuml;RDIGE GR&Uuml;NDE
        F&Uuml;R DIE VERARBEITUNG NACHWEISEN, DIE IHRE INTERESSEN, RECHTE UND
        FREIHEITEN &Uuml;BERWIEGEN ODER DIE VERARBEITUNG DIENT DER
        GELTENDMACHUNG, AUS&Uuml;BUNG ODER VERTEIDIGUNG VON
        RECHTSANSPR&Uuml;CHEN (WIDERSPRUCH NACH ART. 21 ABS. 1 DSGVO).
      </p>{" "}
      <p>
        WERDEN IHRE PERSONENBEZOGENEN DATEN VERARBEITET, UM DIREKTWERBUNG ZU
        BETREIBEN, SO HABEN SIE DAS RECHT, JEDERZEIT WIDERSPRUCH GEGEN DIE
        VERARBEITUNG SIE BETREFFENDER PERSONENBEZOGENER DATEN ZUM ZWECKE
        DERARTIGER WERBUNG EINZULEGEN; DIES GILT AUCH F&Uuml;R DAS PROFILING,
        SOWEIT ES MIT SOLCHER DIREKTWERBUNG IN VERBINDUNG STEHT. WENN SIE
        WIDERSPRECHEN, WERDEN IHRE PERSONENBEZOGENEN DATEN ANSCHLIESSEND NICHT
        MEHR ZUM ZWECKE DER DIREKTWERBUNG VERWENDET (WIDERSPRUCH NACH ART. 21
        ABS. 2 DSGVO).
      </p>
      <h3>
        Beschwerde&shy;recht bei der zust&auml;ndigen Aufsichts&shy;beh&ouml;rde
      </h3>{" "}
      <p>
        Im Falle von Verst&ouml;&szlig;en gegen die DSGVO steht den Betroffenen
        ein Beschwerderecht bei einer Aufsichtsbeh&ouml;rde, insbesondere in dem
        Mitgliedstaat ihres gew&ouml;hnlichen Aufenthalts, ihres Arbeitsplatzes
        oder des Orts des mutma&szlig;lichen Versto&szlig;es zu. Das
        Beschwerderecht besteht unbeschadet anderweitiger verwaltungsrechtlicher
        oder gerichtlicher Rechtsbehelfe.
      </p>
      <h3>Recht auf Daten&shy;&uuml;bertrag&shy;barkeit</h3>{" "}
      <p>
        Sie haben das Recht, Daten, die wir auf Grundlage Ihrer Einwilligung
        oder in Erf&uuml;llung eines Vertrags automatisiert verarbeiten, an sich
        oder an einen Dritten in einem g&auml;ngigen, maschinenlesbaren Format
        aush&auml;ndigen zu lassen. Sofern Sie die direkte &Uuml;bertragung der
        Daten an einen anderen Verantwortlichen verlangen, erfolgt dies nur,
        soweit es technisch machbar ist.
      </p>
      <h3>Auskunft, Berichtigung und L&ouml;schung</h3>{" "}
      <p>
        Sie haben im Rahmen der geltenden gesetzlichen Bestimmungen jederzeit
        das Recht auf unentgeltliche Auskunft &uuml;ber Ihre gespeicherten
        personenbezogenen Daten, deren Herkunft und Empf&auml;nger und den Zweck
        der Datenverarbeitung und ggf. ein Recht auf Berichtigung oder
        L&ouml;schung dieser Daten. Hierzu sowie zu weiteren Fragen zum Thema
        personenbezogene Daten k&ouml;nnen Sie sich jederzeit an uns wenden.
      </p>
      <h3>Recht auf Einschr&auml;nkung der Verarbeitung</h3>{" "}
      <p>
        Sie haben das Recht, die Einschr&auml;nkung der Verarbeitung Ihrer
        personenbezogenen Daten zu verlangen. Hierzu k&ouml;nnen Sie sich
        jederzeit an uns wenden. Das Recht auf Einschr&auml;nkung der
        Verarbeitung besteht in folgenden F&auml;llen:
      </p>{" "}
      <ul>
        {" "}
        <li>
          Wenn Sie die Richtigkeit Ihrer bei uns gespeicherten personenbezogenen
          Daten bestreiten, ben&ouml;tigen wir in der Regel Zeit, um dies zu
          &uuml;berpr&uuml;fen. F&uuml;r die Dauer der Pr&uuml;fung haben Sie
          das Recht, die Einschr&auml;nkung der Verarbeitung Ihrer
          personenbezogenen Daten zu verlangen.
        </li>{" "}
        <li>
          Wenn die Verarbeitung Ihrer personenbezogenen Daten
          unrechtm&auml;&szlig;ig geschah/geschieht, k&ouml;nnen Sie statt der
          L&ouml;schung die Einschr&auml;nkung der Datenverarbeitung verlangen.
        </li>{" "}
        <li>
          Wenn wir Ihre personenbezogenen Daten nicht mehr ben&ouml;tigen, Sie
          sie jedoch zur Aus&uuml;bung, Verteidigung oder Geltendmachung von
          Rechtsanspr&uuml;chen ben&ouml;tigen, haben Sie das Recht, statt der
          L&ouml;schung die Einschr&auml;nkung der Verarbeitung Ihrer
          personenbezogenen Daten zu verlangen.
        </li>{" "}
        <li>
          Wenn Sie einen Widerspruch nach Art. 21 Abs. 1 DSGVO eingelegt haben,
          muss eine Abw&auml;gung zwischen Ihren und unseren Interessen
          vorgenommen werden. Solange noch nicht feststeht, wessen Interessen
          &uuml;berwiegen, haben Sie das Recht, die Einschr&auml;nkung der
          Verarbeitung Ihrer personenbezogenen Daten zu verlangen.
        </li>{" "}
      </ul>{" "}
      <p>
        Wenn Sie die Verarbeitung Ihrer personenbezogenen Daten
        eingeschr&auml;nkt haben, d&uuml;rfen diese Daten &ndash; von ihrer
        Speicherung abgesehen &ndash; nur mit Ihrer Einwilligung oder zur
        Geltendmachung, Aus&uuml;bung oder Verteidigung von
        Rechtsanspr&uuml;chen oder zum Schutz der Rechte einer anderen
        nat&uuml;rlichen oder juristischen Person oder aus Gr&uuml;nden eines
        wichtigen &ouml;ffentlichen Interesses der Europ&auml;ischen Union oder
        eines Mitgliedstaats verarbeitet werden.
      </p>
      <h3>SSL- bzw. TLS-Verschl&uuml;sselung</h3>{" "}
      <p>
        Diese Seite nutzt aus Sicherheitsgr&uuml;nden und zum Schutz der
        &Uuml;bertragung vertraulicher Inhalte, wie zum Beispiel Bestellungen
        oder Anfragen, die Sie an uns als Seitenbetreiber senden, eine SSL- bzw.
        TLS-Verschl&uuml;sselung. Eine verschl&uuml;sselte Verbindung erkennen
        Sie daran, dass die Adresszeile des Browsers von &bdquo;http://&ldquo;
        auf &bdquo;https://&ldquo; wechselt und an dem Schloss-Symbol in Ihrer
        Browserzeile.
      </p>{" "}
      <p>
        Wenn die SSL- bzw. TLS-Verschl&uuml;sselung aktiviert ist, k&ouml;nnen
        die Daten, die Sie an uns &uuml;bermitteln, nicht von Dritten mitgelesen
        werden.
      </p>
      <h2>4. Datenerfassung auf dieser Website</h2>
      <h3>Cookies</h3>{" "}
      <p>
        Unsere Internetseiten verwenden so genannte &bdquo;Cookies&ldquo;.
        Cookies sind kleine Datenpakete und richten auf Ihrem Endger&auml;t
        keinen Schaden an. Sie werden entweder vor&uuml;bergehend f&uuml;r die
        Dauer einer Sitzung (Session-Cookies) oder dauerhaft (permanente
        Cookies) auf Ihrem Endger&auml;t gespeichert. Session-Cookies werden
        nach Ende Ihres Besuchs automatisch gel&ouml;scht. Permanente Cookies
        bleiben auf Ihrem Endger&auml;t gespeichert, bis Sie diese selbst
        l&ouml;schen oder eine automatische L&ouml;schung durch Ihren Webbrowser
        erfolgt.
      </p>{" "}
      <p>
        Cookies k&ouml;nnen von uns (First-Party-Cookies) oder von
        Drittunternehmen stammen (sog. Third-Party-Cookies). Third-Party-Cookies
        erm&ouml;glichen die Einbindung bestimmter Dienstleistungen von
        Drittunternehmen innerhalb von Webseiten (z.&nbsp;B. Cookies zur
        Abwicklung von Zahlungsdienstleistungen).
      </p>{" "}
      <p>
        Cookies haben verschiedene Funktionen. Zahlreiche Cookies sind technisch
        notwendig, da bestimmte Webseitenfunktionen ohne diese nicht
        funktionieren w&uuml;rden (z.&nbsp;B. die Warenkorbfunktion oder die
        Anzeige von Videos). Andere Cookies k&ouml;nnen zur Auswertung des
        Nutzerverhaltens oder zu Werbezwecken verwendet werden.
      </p>{" "}
      <p>
        Cookies, die zur Durchf&uuml;hrung des elektronischen
        Kommunikationsvorgangs, zur Bereitstellung bestimmter, von Ihnen
        erw&uuml;nschter Funktionen (z.&nbsp;B. f&uuml;r die Warenkorbfunktion)
        oder zur Optimierung der Website (z.&nbsp;B. Cookies zur Messung des
        Webpublikums) erforderlich sind (notwendige Cookies), werden auf
        Grundlage von Art. 6 Abs. 1 lit. f DSGVO gespeichert, sofern keine
        andere Rechtsgrundlage angegeben wird. Der Websitebetreiber hat ein
        berechtigtes Interesse an der Speicherung von notwendigen Cookies zur
        technisch fehlerfreien und optimierten Bereitstellung seiner Dienste.
        Sofern eine Einwilligung zur Speicherung von Cookies und vergleichbaren
        Wiedererkennungstechnologien abgefragt wurde, erfolgt die Verarbeitung
        ausschlie&szlig;lich auf Grundlage dieser Einwilligung (Art. 6 Abs. 1
        lit. a DSGVO und &sect; 25 Abs. 1 TDDDG); die Einwilligung ist jederzeit
        widerrufbar.
      </p>{" "}
      <p>
        Sie k&ouml;nnen Ihren Browser so einstellen, dass Sie &uuml;ber das
        Setzen von Cookies informiert werden und Cookies nur im Einzelfall
        erlauben, die Annahme von Cookies f&uuml;r bestimmte F&auml;lle oder
        generell ausschlie&szlig;en sowie das automatische L&ouml;schen der
        Cookies beim Schlie&szlig;en des Browsers aktivieren. Bei der
        Deaktivierung von Cookies kann die Funktionalit&auml;t dieser Website
        eingeschr&auml;nkt sein.
      </p>{" "}
      <p>
        Welche Cookies und Dienste auf dieser Website eingesetzt werden,
        k&ouml;nnen Sie dieser Datenschutzerkl&auml;rung entnehmen.
      </p>
      <h3>Server-Log-Dateien</h3>{" "}
      <p>
        Der Provider der Seiten erhebt und speichert automatisch Informationen
        in so genannten Server-Log-Dateien, die Ihr Browser automatisch an uns
        &uuml;bermittelt. Dies sind:
      </p>{" "}
      <ul>
        {" "}
        <li>Browsertyp und Browserversion</li>{" "}
        <li>verwendetes Betriebssystem</li> <li>Referrer URL</li>{" "}
        <li>Hostname des zugreifenden Rechners</li>{" "}
        <li>Uhrzeit der Serveranfrage</li> <li>IP-Adresse</li>{" "}
      </ul>{" "}
      <p>
        Eine Zusammenf&uuml;hrung dieser Daten mit anderen Datenquellen wird
        nicht vorgenommen.
      </p>{" "}
      <p>
        Die Erfassung dieser Daten erfolgt auf Grundlage von Art. 6 Abs. 1 lit.
        f DSGVO. Der Websitebetreiber hat ein berechtigtes Interesse an der
        technisch fehlerfreien Darstellung und der Optimierung seiner Website
        &ndash; hierzu m&uuml;ssen die Server-Log-Files erfasst werden.
      </p>
      <h3>Kontaktformular</h3>{" "}
      <p>
        Wenn Sie uns per Kontaktformular Anfragen zukommen lassen, werden Ihre
        Angaben aus dem Anfrageformular inklusive der von Ihnen dort angegebenen
        Kontaktdaten zwecks Bearbeitung der Anfrage und f&uuml;r den Fall von
        Anschlussfragen bei uns gespeichert. Diese Daten geben wir nicht ohne
        Ihre Einwilligung weiter.
      </p>{" "}
      <p>
        Die Verarbeitung dieser Daten erfolgt auf Grundlage von Art. 6 Abs. 1
        lit. b DSGVO, sofern Ihre Anfrage mit der Erf&uuml;llung eines Vertrags
        zusammenh&auml;ngt oder zur Durchf&uuml;hrung vorvertraglicher
        Ma&szlig;nahmen erforderlich ist. In allen &uuml;brigen F&auml;llen
        beruht die Verarbeitung auf unserem berechtigten Interesse an der
        effektiven Bearbeitung der an uns gerichteten Anfragen (Art. 6 Abs. 1
        lit. f DSGVO) oder auf Ihrer Einwilligung (Art. 6 Abs. 1 lit. a DSGVO)
        sofern diese abgefragt wurde; die Einwilligung ist jederzeit
        widerrufbar.
      </p>{" "}
      <p>
        Die von Ihnen im Kontaktformular eingegebenen Daten verbleiben bei uns,
        bis Sie uns zur L&ouml;schung auffordern, Ihre Einwilligung zur
        Speicherung widerrufen oder der Zweck f&uuml;r die Datenspeicherung
        entf&auml;llt (z.&nbsp;B. nach abgeschlossener Bearbeitung Ihrer
        Anfrage). Zwingende gesetzliche Bestimmungen &ndash; insbesondere
        Aufbewahrungsfristen &ndash; bleiben unber&uuml;hrt.
      </p>
      <h3>Anfrage per E-Mail, Telefon oder Telefax</h3>{" "}
      <p>
        Wenn Sie uns per E-Mail, Telefon oder Telefax kontaktieren, wird Ihre
        Anfrage inklusive aller daraus hervorgehenden personenbezogenen Daten
        (Name, Anfrage) zum Zwecke der Bearbeitung Ihres Anliegens bei uns
        gespeichert und verarbeitet. Diese Daten geben wir nicht ohne Ihre
        Einwilligung weiter.
      </p>{" "}
      <p>
        Die Verarbeitung dieser Daten erfolgt auf Grundlage von Art. 6 Abs. 1
        lit. b DSGVO, sofern Ihre Anfrage mit der Erf&uuml;llung eines Vertrags
        zusammenh&auml;ngt oder zur Durchf&uuml;hrung vorvertraglicher
        Ma&szlig;nahmen erforderlich ist. In allen &uuml;brigen F&auml;llen
        beruht die Verarbeitung auf unserem berechtigten Interesse an der
        effektiven Bearbeitung der an uns gerichteten Anfragen (Art. 6 Abs. 1
        lit. f DSGVO) oder auf Ihrer Einwilligung (Art. 6 Abs. 1 lit. a DSGVO)
        sofern diese abgefragt wurde; die Einwilligung ist jederzeit
        widerrufbar.
      </p>{" "}
      <p>
        Die von Ihnen an uns per Kontaktanfragen &uuml;bersandten Daten
        verbleiben bei uns, bis Sie uns zur L&ouml;schung auffordern, Ihre
        Einwilligung zur Speicherung widerrufen oder der Zweck f&uuml;r die
        Datenspeicherung entf&auml;llt (z.&nbsp;B. nach abgeschlossener
        Bearbeitung Ihres Anliegens). Zwingende gesetzliche Bestimmungen &ndash;
        insbesondere gesetzliche Aufbewahrungsfristen &ndash; bleiben
        unber&uuml;hrt.
      </p>
      <h2>5. Soziale Medien</h2>
      <h3>Facebook</h3>{" "}
      <p>
        Auf dieser Website sind Elemente des sozialen Netzwerks Facebook
        integriert. Anbieter dieses Dienstes ist die Meta Platforms Ireland
        Limited, Merrion Road, Dublin 4, D04 X2K5, Irland. Die erfassten Daten
        werden nach Aussage von Facebook jedoch auch in die USA und in andere
        Drittl&auml;nder &uuml;bertragen.
      </p>{" "}
      <p>
        Eine &Uuml;bersicht &uuml;ber die Facebook Social-Media-Elemente finden
        Sie hier:{" "}
        <a
          href="https://developers.facebook.com/docs/plugins/?locale=de_DE"
          target="_blank"
          rel="noopener noreferrer"
        >
          https://developers.facebook.com/docs/plugins/?locale=de_DE
        </a>
        .
      </p>{" "}
      <p>
        Wenn das Social-Media-Element aktiv ist, wird eine direkte Verbindung
        zwischen Ihrem Endger&auml;t und dem Facebook-Server hergestellt.
        Facebook erh&auml;lt dadurch die Information, dass Sie mit Ihrer
        IP-Adresse diese Website besucht haben. Wenn Sie den Facebook
        &bdquo;Like-Button&ldquo; anklicken, w&auml;hrend Sie in Ihrem
        Facebook-Account eingeloggt sind, k&ouml;nnen Sie die Inhalte dieser
        Website auf Ihrem Facebook-Profil verlinken. Dadurch kann Facebook den
        Besuch dieser Website Ihrem Benutzerkonto zuordnen. Wir weisen darauf
        hin, dass wir als Anbieter der Seiten keine Kenntnis vom Inhalt der
        &uuml;bermittelten Daten sowie deren Nutzung durch Facebook erhalten.
        Weitere Informationen hierzu finden Sie in der Datenschutzerkl&auml;rung
        von Facebook unter:{" "}
        <a
          href="https://de-de.facebook.com/privacy/explanation"
          target="_blank"
          rel="noopener noreferrer"
        >
          https://de-de.facebook.com/privacy/explanation
        </a>
        .
      </p>{" "}
      <p>
        Die Nutzung dieses Dienstes erfolgt auf Grundlage Ihrer Einwilligung
        nach Art. 6 Abs. 1 lit. a DSGVO und &sect; 25 Abs. 1 TDDDG. Die
        Einwilligung ist jederzeit widerrufbar.
      </p>{" "}
      <p>
        Soweit mit Hilfe des hier beschriebenen Tools personenbezogene Daten auf
        unserer Website erfasst und an Facebook weitergeleitet werden, sind wir
        und die Meta Platforms Ireland Limited, 4 Grand Canal Square, Grand
        Canal Harbour, Dublin 2, Irland gemeinsam f&uuml;r diese
        Datenverarbeitung verantwortlich (Art. 26 DSGVO). Die gemeinsame
        Verantwortlichkeit beschr&auml;nkt sich dabei ausschlie&szlig;lich auf
        die Erfassung der Daten und deren Weitergabe an Facebook. Die nach der
        Weiterleitung erfolgende Verarbeitung durch Facebook ist nicht Teil der
        gemeinsamen Verantwortung. Die uns gemeinsam obliegenden Verpflichtungen
        wurden in einer Vereinbarung &uuml;ber gemeinsame Verarbeitung
        festgehalten. Den Wortlaut der Vereinbarung finden Sie unter:{" "}
        <a
          href="https://www.facebook.com/legal/controller_addendum"
          target="_blank"
          rel="noopener noreferrer"
        >
          https://www.facebook.com/legal/controller_addendum
        </a>
        . Laut dieser Vereinbarung sind wir f&uuml;r die Erteilung der
        Datenschutzinformationen beim Einsatz des Facebook-Tools und f&uuml;r
        die datenschutzrechtlich sichere Implementierung des Tools auf unserer
        Website verantwortlich. F&uuml;r die Datensicherheit der
        Facebook-Produkte ist Facebook verantwortlich. Betroffenenrechte
        (z.&nbsp;B. Auskunftsersuchen) hinsichtlich der bei Facebook
        verarbeiteten Daten k&ouml;nnen Sie direkt bei Facebook geltend machen.
        Wenn Sie die Betroffenenrechte bei uns geltend machen, sind wir
        verpflichtet, diese an Facebook weiterzuleiten.
      </p>{" "}
      <p>
        Die Daten&uuml;bertragung in die USA wird auf die
        Standardvertragsklauseln der EU-Kommission gest&uuml;tzt. Details finden
        Sie hier:{" "}
        <a
          href="https://www.facebook.com/legal/EU_data_transfer_addendum"
          target="_blank"
          rel="noopener noreferrer"
        >
          https://www.facebook.com/legal/EU_data_transfer_addendum
        </a>
        ,{" "}
        <a
          href="https://de-de.facebook.com/help/566994660333381"
          target="_blank"
          rel="noopener noreferrer"
        >
          https://de-de.facebook.com/help/566994660333381
        </a>{" "}
        und{" "}
        <a
          href="https://www.facebook.com/policy.php"
          target="_blank"
          rel="noopener noreferrer"
        >
          https://www.facebook.com/policy.php
        </a>
        .
      </p>
      <p>
        Das Unternehmen verf&uuml;gt &uuml;ber eine Zertifizierung nach dem
        &bdquo;EU-US Data Privacy Framework&ldquo; (DPF). Der DPF ist ein
        &Uuml;bereinkommen zwischen der Europ&auml;ischen Union und den USA, der
        die Einhaltung europ&auml;ischer Datenschutzstandards bei
        Datenverarbeitungen in den USA gew&auml;hrleisten soll. Jedes nach dem
        DPF zertifizierte Unternehmen verpflichtet sich, diese
        Datenschutzstandards einzuhalten. Weitere Informationen hierzu erhalten
        Sie vom Anbieter unter folgendem Link:{" "}
        <a
          href="https://www.dataprivacyframework.gov/participant/4452"
          target="_blank"
          rel="noopener noreferrer"
        >
          https://www.dataprivacyframework.gov/participant/4452
        </a>
        .
      </p>
      <h3>Instagram</h3>{" "}
      <p>
        Auf dieser Website sind Funktionen des Dienstes Instagram eingebunden.
        Diese Funktionen werden angeboten durch die Meta Platforms Ireland
        Limited, Merrion Road, Dublin 4, D04 X2K5, Irland.
      </p>{" "}
      <p>
        Wenn das Social-Media-Element aktiv ist, wird eine direkte Verbindung
        zwischen Ihrem Endger&auml;t und dem Instagram-Server hergestellt.
        Instagram erh&auml;lt dadurch Informationen &uuml;ber den Besuch dieser
        Website durch Sie.
      </p>{" "}
      <p>
        Wenn Sie in Ihrem Instagram-Account eingeloggt sind, k&ouml;nnen Sie
        durch Anklicken des Instagram-Buttons die Inhalte dieser Website mit
        Ihrem Instagram-Profil verlinken. Dadurch kann Instagram den Besuch
        dieser Website Ihrem Benutzerkonto zuordnen. Wir weisen darauf hin, dass
        wir als Anbieter der Seiten keine Kenntnis vom Inhalt der
        &uuml;bermittelten Daten sowie deren Nutzung durch Instagram erhalten.
      </p>{" "}
      <p>
        Die Nutzung dieses Dienstes erfolgt auf Grundlage Ihrer Einwilligung
        nach Art. 6 Abs. 1 lit. a DSGVO und &sect; 25 Abs. 1 TDDDG. Die
        Einwilligung ist jederzeit widerrufbar.
      </p>{" "}
      <p>
        Soweit mit Hilfe des hier beschriebenen Tools personenbezogene Daten auf
        unserer Website erfasst und an Facebook bzw. Instagram weitergeleitet
        werden, sind wir und die Meta Platforms Ireland Limited, 4 Grand Canal
        Square, Grand Canal Harbour, Dublin 2, Irland gemeinsam f&uuml;r diese
        Datenverarbeitung verantwortlich (Art. 26 DSGVO). Die gemeinsame
        Verantwortlichkeit beschr&auml;nkt sich dabei ausschlie&szlig;lich auf
        die Erfassung der Daten und deren Weitergabe an Facebook bzw. Instagram.
        Die nach der Weiterleitung erfolgende Verarbeitung durch Facebook bzw.
        Instagram ist nicht Teil der gemeinsamen Verantwortung. Die uns
        gemeinsam obliegenden Verpflichtungen wurden in einer Vereinbarung
        &uuml;ber gemeinsame Verarbeitung festgehalten. Den Wortlaut der
        Vereinbarung finden Sie unter:{" "}
        <a
          href="https://www.facebook.com/legal/controller_addendum"
          target="_blank"
          rel="noopener noreferrer"
        >
          https://www.facebook.com/legal/controller_addendum
        </a>
        . Laut dieser Vereinbarung sind wir f&uuml;r die Erteilung der
        Datenschutzinformationen beim Einsatz des Facebook- bzw. Instagram-Tools
        und f&uuml;r die datenschutzrechtlich sichere Implementierung des Tools
        auf unserer Website verantwortlich. F&uuml;r die Datensicherheit der
        Facebook bzw. Instagram-Produkte ist Facebook verantwortlich.
        Betroffenenrechte (z.&nbsp;B. Auskunftsersuchen) hinsichtlich der bei
        Facebook bzw. Instagram verarbeiteten Daten k&ouml;nnen Sie direkt bei
        Facebook geltend machen. Wenn Sie die Betroffenenrechte bei uns geltend
        machen, sind wir verpflichtet, diese an Facebook weiterzuleiten.
      </p>{" "}
      <p>
        Die Daten&uuml;bertragung in die USA wird auf die
        Standardvertragsklauseln der EU-Kommission gest&uuml;tzt. Details finden
        Sie hier:{" "}
        <a
          href="https://www.facebook.com/legal/EU_data_transfer_addendum"
          target="_blank"
          rel="noopener noreferrer"
        >
          https://www.facebook.com/legal/EU_data_transfer_addendum
        </a>
        ,{" "}
        <a
          href="https://privacycenter.instagram.com/policy/"
          target="_blank"
          rel="noopener noreferrer"
        >
          https://privacycenter.instagram.com/policy/
        </a>{" "}
        und{" "}
        <a
          href="https://de-de.facebook.com/help/566994660333381"
          target="_blank"
          rel="noopener noreferrer"
        >
          https://de-de.facebook.com/help/566994660333381
        </a>
        .
      </p>{" "}
      <p>
        Weitere Informationen hierzu finden Sie in der Datenschutzerkl&auml;rung
        von Instagram:{" "}
        <a
          href="https://privacycenter.instagram.com/policy/"
          target="_blank"
          rel="noopener noreferrer"
        >
          https://privacycenter.instagram.com/policy/
        </a>
        .
      </p>
      <p>
        Das Unternehmen verf&uuml;gt &uuml;ber eine Zertifizierung nach dem
        &bdquo;EU-US Data Privacy Framework&ldquo; (DPF). Der DPF ist ein
        &Uuml;bereinkommen zwischen der Europ&auml;ischen Union und den USA, der
        die Einhaltung europ&auml;ischer Datenschutzstandards bei
        Datenverarbeitungen in den USA gew&auml;hrleisten soll. Jedes nach dem
        DPF zertifizierte Unternehmen verpflichtet sich, diese
        Datenschutzstandards einzuhalten. Weitere Informationen hierzu erhalten
        Sie vom Anbieter unter folgendem Link:{" "}
        <a
          href="https://www.dataprivacyframework.gov/participant/4452"
          target="_blank"
          rel="noopener noreferrer"
        >
          https://www.dataprivacyframework.gov/participant/4452
        </a>
        .
      </p>
      <h3>LinkedIn</h3>{" "}
      <p>
        Diese Website nutzt Elemente des Netzwerks LinkedIn. Anbieter ist die
        LinkedIn Ireland Unlimited Company, Wilton Plaza, Wilton Place, Dublin
        2, Irland.
      </p>{" "}
      <p>
        Bei jedem Abruf einer Seite dieser Website, die Elemente von LinkedIn
        enth&auml;lt, wird eine Verbindung zu Servern von LinkedIn aufgebaut.
        LinkedIn wird dar&uuml;ber informiert, dass Sie diese Website mit Ihrer
        IP-Adresse besucht haben. Wenn Sie den &bdquo;Recommend-Button&ldquo;
        von LinkedIn anklicken und in Ihrem Account bei LinkedIn eingeloggt
        sind, ist es LinkedIn m&ouml;glich, Ihren Besuch auf dieser Website
        Ihnen und Ihrem Benutzerkonto zuzuordnen. Wir weisen darauf hin, dass
        wir als Anbieter der Seiten keine Kenntnis vom Inhalt der
        &uuml;bermittelten Daten sowie deren Nutzung durch LinkedIn haben.
      </p>{" "}
      <p>
        Die Nutzung dieses Dienstes erfolgt auf Grundlage Ihrer Einwilligung
        nach Art. 6 Abs. 1 lit. a DSGVO und &sect; 25 Abs. 1 TDDDG. Die
        Einwilligung ist jederzeit widerrufbar.
      </p>{" "}
      <p>
        Die Daten&uuml;bertragung in die USA wird auf die
        Standardvertragsklauseln der EU-Kommission gest&uuml;tzt. Details finden
        Sie hier:{" "}
        <a
          href="https://www.linkedin.com/help/linkedin/answer/a1343190/datenubertragung-aus-der-eu-dem-ewr-und-der-schweiz?lang=de"
          target="_blank"
          rel="noopener noreferrer"
        >
          https://www.linkedin.com/help/linkedin/answer/a1343190/datenubertragung-aus-der-eu-dem-ewr-und-der-schweiz?lang=de
        </a>
      </p>{" "}
      <p>
        Weitere Informationen hierzu finden Sie in der Datenschutzerkl&auml;rung
        von LinkedIn unter:{" "}
        <a
          href="https://www.linkedin.com/legal/privacy-policy"
          target="_blank"
          rel="noopener noreferrer"
        >
          https://www.linkedin.com/legal/privacy-policy
        </a>
        .
      </p>
      <p>
        Das Unternehmen verf&uuml;gt &uuml;ber eine Zertifizierung nach dem
        &bdquo;EU-US Data Privacy Framework&ldquo; (DPF). Der DPF ist ein
        &Uuml;bereinkommen zwischen der Europ&auml;ischen Union und den USA, der
        die Einhaltung europ&auml;ischer Datenschutzstandards bei
        Datenverarbeitungen in den USA gew&auml;hrleisten soll. Jedes nach dem
        DPF zertifizierte Unternehmen verpflichtet sich, diese
        Datenschutzstandards einzuhalten. Weitere Informationen hierzu erhalten
        Sie vom Anbieter unter folgendem Link:{" "}
        <a
          href="https://www.dataprivacyframework.gov/participant/5448"
          target="_blank"
          rel="noopener noreferrer"
        >
          https://www.dataprivacyframework.gov/participant/5448
        </a>
        .
      </p>
      <h2>6. Analyse-Tools und Werbung</h2>
      <h3>Google Tag Manager</h3>{" "}
      <p>
        Wir setzen den Google Tag Manager ein. Anbieter ist die Google Ireland
        Limited, Gordon House, Barrow Street, Dublin 4, Irland.
      </p>{" "}
      <p>
        Der Google Tag Manager ist ein Tool, mit dessen Hilfe wir Tracking- oder
        Statistik-Tools und andere Technologien auf unserer Website einbinden
        k&ouml;nnen. Der Google Tag Manager selbst erstellt keine Nutzerprofile,
        speichert keine Cookies und nimmt keine eigenst&auml;ndigen Analysen
        vor. Er dient lediglich der Verwaltung und Ausspielung der &uuml;ber ihn
        eingebundenen Tools. Der Google Tag Manager erfasst jedoch Ihre
        IP-Adresse, die auch an das Mutterunternehmen von Google in die
        Vereinigten Staaten &uuml;bertragen werden kann.
      </p>{" "}
      <p>
        Der Einsatz des Google Tag Managers erfolgt auf Grundlage von Art. 6
        Abs. 1 lit. f DSGVO. Der Websitebetreiber hat ein berechtigtes Interesse
        an einer schnellen und unkomplizierten Einbindung und Verwaltung
        verschiedener Tools auf seiner Website. Sofern eine entsprechende
        Einwilligung abgefragt wurde, erfolgt die Verarbeitung
        ausschlie&szlig;lich auf Grundlage von Art. 6 Abs. 1 lit. a DSGVO und
        &sect; 25 Abs. 1 TDDDG, soweit die Einwilligung die Speicherung von
        Cookies oder den Zugriff auf Informationen im Endger&auml;t des Nutzers
        (z.&nbsp;B. Device-Fingerprinting) im Sinne des TDDDG umfasst. Die
        Einwilligung ist jederzeit widerrufbar.
      </p>
      <p>
        Das Unternehmen verf&uuml;gt &uuml;ber eine Zertifizierung nach dem
        &bdquo;EU-US Data Privacy Framework&ldquo; (DPF). Der DPF ist ein
        &Uuml;bereinkommen zwischen der Europ&auml;ischen Union und den USA, der
        die Einhaltung europ&auml;ischer Datenschutzstandards bei
        Datenverarbeitungen in den USA gew&auml;hrleisten soll. Jedes nach dem
        DPF zertifizierte Unternehmen verpflichtet sich, diese
        Datenschutzstandards einzuhalten. Weitere Informationen hierzu erhalten
        Sie vom Anbieter unter folgendem Link:{" "}
        <a
          href="https://www.dataprivacyframework.gov/participant/5780"
          target="_blank"
          rel="noopener noreferrer"
        >
          https://www.dataprivacyframework.gov/participant/5780
        </a>
        .
      </p>
      <h3>Google Analytics</h3>{" "}
      <p>
        Diese Website nutzt Funktionen des Webanalysedienstes Google Analytics.
        Anbieter ist die Google Ireland Limited (&bdquo;Google&ldquo;), Gordon
        House, Barrow Street, Dublin 4, Irland.
      </p>{" "}
      <p>
        Google Analytics erm&ouml;glicht es dem Websitebetreiber, das Verhalten
        der Websitebesucher zu analysieren. Hierbei erh&auml;lt der
        Websitebetreiber verschiedene Nutzungsdaten, wie z.&nbsp;B.
        Seitenaufrufe, Verweildauer, verwendete Betriebssysteme und Herkunft des
        Nutzers. Diese Daten werden in einer User-ID zusammengefasst und dem
        jeweiligen Endger&auml;t des Websitebesuchers zugeordnet.
      </p>{" "}
      <p>
        Des Weiteren k&ouml;nnen wir mit Google Analytics u.&nbsp;a. Ihre Maus-
        und Scrollbewegungen und Klicks aufzeichnen. Ferner verwendet Google
        Analytics verschiedene Modellierungsans&auml;tze, um die erfassten
        Datens&auml;tze zu erg&auml;nzen und setzt Machine-Learning-Technologien
        bei der Datenanalyse ein.
      </p>
      <p>
        Google Analytics verwendet Technologien, die die Wiedererkennung des
        Nutzers zum Zwecke der Analyse des Nutzerverhaltens erm&ouml;glichen
        (z.&nbsp;B. Cookies oder Device-Fingerprinting). Die von Google
        erfassten Informationen &uuml;ber die Benutzung dieser Website werden in
        der Regel an einen Server von Google in den USA &uuml;bertragen und dort
        gespeichert.
      </p>{" "}
      <p>
        Die Nutzung dieses Dienstes erfolgt auf Grundlage Ihrer Einwilligung
        nach Art. 6 Abs. 1 lit. a DSGVO und &sect; 25 Abs. 1 TDDDG. Die
        Einwilligung ist jederzeit widerrufbar.
      </p>{" "}
      <p>
        Die Daten&uuml;bertragung in die USA wird auf die
        Standardvertragsklauseln der EU-Kommission gest&uuml;tzt. Details finden
        Sie hier:{" "}
        <a
          href="https://privacy.google.com/businesses/controllerterms/mccs/"
          target="_blank"
          rel="noopener noreferrer"
        >
          https://privacy.google.com/businesses/controllerterms/mccs/
        </a>
        .
      </p>{" "}
      <p>
        Das Unternehmen verf&uuml;gt &uuml;ber eine Zertifizierung nach dem
        &bdquo;EU-US Data Privacy Framework&ldquo; (DPF). Der DPF ist ein
        &Uuml;bereinkommen zwischen der Europ&auml;ischen Union und den USA, der
        die Einhaltung europ&auml;ischer Datenschutzstandards bei
        Datenverarbeitungen in den USA gew&auml;hrleisten soll. Jedes nach dem
        DPF zertifizierte Unternehmen verpflichtet sich, diese
        Datenschutzstandards einzuhalten. Weitere Informationen hierzu erhalten
        Sie vom Anbieter unter folgendem Link:{" "}
        <a
          href="https://www.dataprivacyframework.gov/participant/5780"
          target="_blank"
          rel="noopener noreferrer"
        >
          https://www.dataprivacyframework.gov/participant/5780
        </a>
        .
      </p>
      <h4>IP Anonymisierung</h4>{" "}
      <p>
        Die Google Analytics IP-Anonymisierung ist aktiviert. Dadurch wird Ihre
        IP-Adresse von Google innerhalb von Mitgliedstaaten der
        Europ&auml;ischen Union oder in anderen Vertragsstaaten des Abkommens
        &uuml;ber den Europ&auml;ischen Wirtschaftsraum vor der
        &Uuml;bermittlung in die USA gek&uuml;rzt. Nur in Ausnahmef&auml;llen
        wird die volle IP-Adresse an einen Server von Google in den USA
        &uuml;bertragen und dort gek&uuml;rzt. Im Auftrag des Betreibers dieser
        Website wird Google diese Informationen benutzen, um Ihre Nutzung der
        Website auszuwerten, um Reports &uuml;ber die Websiteaktivit&auml;ten
        zusammenzustellen und um weitere mit der Websitenutzung und der
        Internetnutzung verbundene Dienstleistungen gegen&uuml;ber dem
        Websitebetreiber zu erbringen. Die im Rahmen von Google Analytics von
        Ihrem Browser &uuml;bermittelte IP-Adresse wird nicht mit anderen Daten
        von Google zusammengef&uuml;hrt.
      </p>
      <h4>Browser Plugin</h4>{" "}
      <p>
        Sie k&ouml;nnen die Erfassung und Verarbeitung Ihrer Daten durch Google
        verhindern, indem Sie das unter dem folgenden Link verf&uuml;gbare
        Browser-Plugin herunterladen und installieren:{" "}
        <a
          href="https://tools.google.com/dlpage/gaoptout?hl=de"
          target="_blank"
          rel="noopener noreferrer"
        >
          https://tools.google.com/dlpage/gaoptout?hl=de
        </a>
        .
      </p>{" "}
      <p>
        Mehr Informationen zum Umgang mit Nutzerdaten bei Google Analytics
        finden Sie in der Datenschutzerkl&auml;rung von Google:{" "}
        <a
          href="https://support.google.com/analytics/answer/6004245?hl=de"
          target="_blank"
          rel="noopener noreferrer"
        >
          https://support.google.com/analytics/answer/6004245?hl=de
        </a>
        .
      </p>
      <h4>Auftragsverarbeitung</h4>{" "}
      <p>
        Wir haben mit Google einen Vertrag zur Auftragsverarbeitung
        abgeschlossen und setzen die strengen Vorgaben der deutschen
        Datenschutzbeh&ouml;rden bei der Nutzung von Google Analytics
        vollst&auml;ndig um.
      </p>
      <h3>Google Ads</h3>{" "}
      <p>
        Der Websitebetreiber verwendet Google Ads. Google Ads ist ein
        Online-Werbeprogramm der Google Ireland Limited (&bdquo;Google&ldquo;),
        Gordon House, Barrow Street, Dublin 4, Irland.
      </p>{" "}
      <p>
        Google Ads erm&ouml;glicht es uns Werbeanzeigen in der
        Google-Suchmaschine oder auf Drittwebseiten auszuspielen, wenn der
        Nutzer bestimmte Suchbegriffe bei Google eingibt (Keyword-Targeting).
        Ferner k&ouml;nnen zielgerichtete Werbeanzeigen anhand der bei Google
        vorhandenen Nutzerdaten (z.&nbsp;B. Standortdaten und Interessen)
        ausgespielt werden (Zielgruppen-Targeting). Wir als Websitebetreiber
        k&ouml;nnen diese Daten quantitativ auswerten, indem wir beispielsweise
        analysieren, welche Suchbegriffe zur Ausspielung unserer Werbeanzeigen
        gef&uuml;hrt haben und wie viele Anzeigen zu entsprechenden Klicks
        gef&uuml;hrt haben.
      </p>{" "}
      <p>
        Die Nutzung dieses Dienstes erfolgt auf Grundlage Ihrer Einwilligung
        nach Art. 6 Abs. 1 lit. a DSGVO und &sect; 25 Abs. 1 TDDDG. Die
        Einwilligung ist jederzeit widerrufbar.
      </p>{" "}
      <p>
        Die Daten&uuml;bertragung in die USA wird auf die
        Standardvertragsklauseln der EU-Kommission gest&uuml;tzt. Details finden
        Sie hier:{" "}
        <a
          href="https://policies.google.com/privacy/frameworks"
          target="_blank"
          rel="noopener noreferrer"
        >
          https://policies.google.com/privacy/frameworks
        </a>{" "}
        und{" "}
        <a
          href="https://business.safety.google/controllerterms/"
          target="_blank"
          rel="noopener noreferrer"
        >
          https://business.safety.google/controllerterms/
        </a>
        .
      </p>
      <p>
        Das Unternehmen verf&uuml;gt &uuml;ber eine Zertifizierung nach dem
        &bdquo;EU-US Data Privacy Framework&ldquo; (DPF). Der DPF ist ein
        &Uuml;bereinkommen zwischen der Europ&auml;ischen Union und den USA, der
        die Einhaltung europ&auml;ischer Datenschutzstandards bei
        Datenverarbeitungen in den USA gew&auml;hrleisten soll. Jedes nach dem
        DPF zertifizierte Unternehmen verpflichtet sich, diese
        Datenschutzstandards einzuhalten. Weitere Informationen hierzu erhalten
        Sie vom Anbieter unter folgendem Link:{" "}
        <a
          href="https://www.dataprivacyframework.gov/participant/5780"
          target="_blank"
          rel="noopener noreferrer"
        >
          https://www.dataprivacyframework.gov/participant/5780
        </a>
        .
      </p>
      <h3>Google AdSense</h3>{" "}
      <p>
        Diese Website nutzt Google AdSense, einen Dienst zum Einbinden von
        Werbeanzeigen. Anbieter ist die Google Ireland Limited
        (&bdquo;Google&ldquo;), Gordon House, Barrow Street, Dublin 4, Irland.
      </p>{" "}
      <p>
        Mit Hilfe von Google Adsense k&ouml;nnen wir zielgerichtete
        Werbeanzeigen von Drittunternehmen auf unserer Seite einblenden lassen.
        Die Inhalte der Werbeanzeigen richten sich hierbei nach Ihren
        Interessen, die Google anhand Ihres bisherigen Nutzerverhaltens
        ermittelt. Des Weiteren werden bei der Auswahl der passenden
        Werbeanzeige auch Kontextinformationen, wie Ihr Standort, der Inhalt der
        besuchten Webseite oder die von Ihnen eingegeben Google-Suchbegriffe
        ber&uuml;cksichtigt.
      </p>{" "}
      <p>
        Google AdSense verwendet Cookies, Web Beacons (unsichtbare Grafiken) und
        vergleichbare Wiedererkennungstechnologien. Hiermit k&ouml;nnen
        Informationen wie der Besucherverkehr auf diesen Seiten ausgewertet
        werden.
      </p>{" "}
      <p>
        Die von Google Adsense erfassten Informationen &uuml;ber die Benutzung
        dieser Website (einschlie&szlig;lich Ihrer IP-Adresse) und Auslieferung
        von Werbeformaten werden an einen Server von Google in den USA
        &uuml;bertragen und dort gespeichert. Diese Informationen k&ouml;nnen
        von Google an Vertragspartner von Google weitergegeben werden. Google
        wird Ihre IP-Adresse jedoch nicht mit anderen von Ihnen gespeicherten
        Daten zusammenf&uuml;hren.
      </p>{" "}
      <p>
        Die Nutzung dieses Dienstes erfolgt auf Grundlage Ihrer Einwilligung
        nach Art. 6 Abs. 1 lit. a DSGVO und &sect; 25 Abs. 1 TDDDG. Die
        Einwilligung ist jederzeit widerrufbar.
      </p>{" "}
      <p>
        Die Daten&uuml;bertragung in die USA wird auf die
        Standardvertragsklauseln der EU-Kommission gest&uuml;tzt. Details finden
        Sie hier:{" "}
        <a
          href="https://privacy.google.com/businesses/controllerterms/mccs/"
          target="_blank"
          rel="noopener noreferrer"
        >
          https://privacy.google.com/businesses/controllerterms/mccs/
        </a>
        .
      </p>
      <p>
        Das Unternehmen verf&uuml;gt &uuml;ber eine Zertifizierung nach dem
        &bdquo;EU-US Data Privacy Framework&ldquo; (DPF). Der DPF ist ein
        &Uuml;bereinkommen zwischen der Europ&auml;ischen Union und den USA, der
        die Einhaltung europ&auml;ischer Datenschutzstandards bei
        Datenverarbeitungen in den USA gew&auml;hrleisten soll. Jedes nach dem
        DPF zertifizierte Unternehmen verpflichtet sich, diese
        Datenschutzstandards einzuhalten. Weitere Informationen hierzu erhalten
        Sie vom Anbieter unter folgendem Link:{" "}
        <a
          href="https://www.dataprivacyframework.gov/participant/5780"
          target="_blank"
          rel="noopener noreferrer"
        >
          https://www.dataprivacyframework.gov/participant/5780
        </a>
        .
      </p>
      <h3>Google Ads Remarketing</h3>{" "}
      <p>
        Diese Website nutzt die Funktionen von Google Ads Remarketing. Anbieter
        ist die Google Ireland Limited (&bdquo;Google&ldquo;), Gordon House,
        Barrow Street, Dublin 4, Irland.
      </p>{" "}
      <p>
        Mit Google Ads Remarketing k&ouml;nnen wir Personen, die mit unserem
        Online-Angebot interagieren bestimmten Zielgruppen zuordnen, um ihnen
        anschlie&szlig;end interessenbezogene Werbung im Google-Werbenetzwerk
        anzeigen zu lassen (Remarketing bzw. Retargeting).
      </p>{" "}
      <p>
        Des Weiteren k&ouml;nnen die mit Google Ads Remarketing erstellten
        Werbe-Zielgruppen mit den ger&auml;te&uuml;bergreifenden Funktionen von
        Google verkn&uuml;pft werden. Auf diese Weise k&ouml;nnen
        interessenbezogene, personalisierte Werbebotschaften, die in
        Abh&auml;ngigkeit Ihres fr&uuml;heren Nutzungs- und Surfverhaltens auf
        einem Endger&auml;t (z.&nbsp;B. Handy) an Sie angepasst wurden auch auf
        einem anderen Ihrer Endger&auml;te (z.&nbsp;B. Tablet oder PC) angezeigt
        werden.
      </p>{" "}
      <p>
        Wenn Sie &uuml;ber einen Google-Account verf&uuml;gen, k&ouml;nnen Sie
        der personalisierten Werbung unter folgendem Link widersprechen:{" "}
        <a
          href="https://adssettings.google.com/anonymous?hl=de"
          target="_blank"
          rel="noopener noreferrer"
        >
          https://adssettings.google.com/anonymous?hl=de
        </a>
        .
      </p>{" "}
      <p>
        Die Nutzung dieses Dienstes erfolgt auf Grundlage Ihrer Einwilligung
        nach Art. 6 Abs. 1 lit. a DSGVO und &sect; 25 Abs. 1 TDDDG. Die
        Einwilligung ist jederzeit widerrufbar.
      </p>{" "}
      <p>
        Weitergehende Informationen und die Datenschutzbestimmungen finden Sie
        in der Datenschutzerkl&auml;rung von Google unter:{" "}
        <a
          href="https://policies.google.com/technologies/ads?hl=de"
          target="_blank"
          rel="noopener noreferrer"
        >
          https://policies.google.com/technologies/ads?hl=de
        </a>
        .
      </p>
      <p>
        Das Unternehmen verf&uuml;gt &uuml;ber eine Zertifizierung nach dem
        &bdquo;EU-US Data Privacy Framework&ldquo; (DPF). Der DPF ist ein
        &Uuml;bereinkommen zwischen der Europ&auml;ischen Union und den USA, der
        die Einhaltung europ&auml;ischer Datenschutzstandards bei
        Datenverarbeitungen in den USA gew&auml;hrleisten soll. Jedes nach dem
        DPF zertifizierte Unternehmen verpflichtet sich, diese
        Datenschutzstandards einzuhalten. Weitere Informationen hierzu erhalten
        Sie vom Anbieter unter folgendem Link:{" "}
        <a
          href="https://www.dataprivacyframework.gov/participant/5780"
          target="_blank"
          rel="noopener noreferrer"
        >
          https://www.dataprivacyframework.gov/participant/5780
        </a>
        .
      </p>
      <h4>Zielgruppenbildung mit Kundenabgleich</h4>{" "}
      <p>
        Zur Zielgruppenbildung verwenden wir unter anderem den Kundenabgleich
        von Google Ads Remarketing. Hierbei &uuml;bergeben wir bestimmte
        Kundendaten (z.&nbsp;B. E-Mail-Adressen) aus unseren Kundenlisten an
        Google. Sind die betreffenden Kunden Google-Nutzer und in ihrem
        Google-Konto eingeloggt, werden ihnen passende Werbebotschaften
        innerhalb des Google-Netzwerks (z.&nbsp;B. bei YouTube, Gmail oder in
        der Suchmaschine) angezeigt.
      </p>
      <h3>Google Conversion-Tracking</h3>{" "}
      <p>
        Diese Website nutzt Google Conversion Tracking. Anbieter ist die Google
        Ireland Limited (&bdquo;Google&ldquo;), Gordon House, Barrow Street,
        Dublin 4, Irland.
      </p>{" "}
      <p>
        Mit Hilfe von Google-Conversion-Tracking k&ouml;nnen Google und wir
        erkennen, ob der Nutzer bestimmte Aktionen durchgef&uuml;hrt hat. So
        k&ouml;nnen wir beispielsweise auswerten, welche Buttons auf unserer
        Website wie h&auml;ufig geklickt und welche Produkte besonders
        h&auml;ufig angesehen oder gekauft wurden. Diese Informationen dienen
        dazu, Conversion-Statistiken zu erstellen. Wir erfahren die Gesamtanzahl
        der Nutzer, die auf unsere Anzeigen geklickt haben und welche Aktionen
        sie durchgef&uuml;hrt haben. Wir erhalten keine Informationen, mit denen
        wir den Nutzer pers&ouml;nlich identifizieren k&ouml;nnen. Google selbst
        nutzt zur Identifikation Cookies oder vergleichbare
        Wiedererkennungstechnologien.
      </p>{" "}
      <p>
        Die Nutzung dieses Dienstes erfolgt auf Grundlage Ihrer Einwilligung
        nach Art. 6 Abs. 1 lit. a DSGVO und &sect; 25 Abs. 1 TDDDG. Die
        Einwilligung ist jederzeit widerrufbar.
      </p>{" "}
      <p>
        Mehr Informationen zu Google Conversion-Tracking finden Sie in den
        Datenschutzbestimmungen von Google:{" "}
        <a
          href="https://policies.google.com/privacy?hl=de"
          target="_blank"
          rel="noopener noreferrer"
        >
          https://policies.google.com/privacy?hl=de
        </a>
        .
      </p>
      <p>
        Das Unternehmen verf&uuml;gt &uuml;ber eine Zertifizierung nach dem
        &bdquo;EU-US Data Privacy Framework&ldquo; (DPF). Der DPF ist ein
        &Uuml;bereinkommen zwischen der Europ&auml;ischen Union und den USA, der
        die Einhaltung europ&auml;ischer Datenschutzstandards bei
        Datenverarbeitungen in den USA gew&auml;hrleisten soll. Jedes nach dem
        DPF zertifizierte Unternehmen verpflichtet sich, diese
        Datenschutzstandards einzuhalten. Weitere Informationen hierzu erhalten
        Sie vom Anbieter unter folgendem Link:{" "}
        <a
          href="https://www.dataprivacyframework.gov/participant/5780"
          target="_blank"
          rel="noopener noreferrer"
        >
          https://www.dataprivacyframework.gov/participant/5780
        </a>
        .
      </p>
      <h3>Meta-Pixel (ehemals Facebook Pixel)</h3>{" "}
      <p>
        Diese Website nutzt zur Konversionsmessung den Besucheraktions-Pixel von
        Meta. Anbieter dieses Dienstes ist die Meta Platforms Ireland Limited, 4
        Grand Canal Square, Dublin 2, Irland. Die erfassten Daten werden nach
        Aussage von Meta jedoch auch in die USA und in andere Drittl&auml;nder
        &uuml;bertragen.
      </p>{" "}
      <p>
        So kann das Verhalten der Seitenbesucher nachverfolgt werden, nachdem
        diese durch Klick auf eine Meta-Werbeanzeige auf die Website des
        Anbieters weitergeleitet wurden. Dadurch kann die Wirksamkeit der
        Meta-Werbeanzeigen f&uuml;r statistische und Marktforschungszwecke
        ausgewertet werden und zuk&uuml;nftige Werbema&szlig;nahmen optimiert
        werden.
      </p>{" "}
      <p>
        Die erhobenen Daten sind f&uuml;r uns als Betreiber dieser Website
        anonym, wir k&ouml;nnen keine R&uuml;ckschl&uuml;sse auf die
        Identit&auml;t der Nutzer ziehen. Die Daten werden aber von Meta
        gespeichert und verarbeitet, sodass eine Verbindung zum jeweiligen
        Nutzerprofil bei Facebook oder Instagram m&ouml;glich ist und Meta die
        Daten f&uuml;r eigene Werbezwecke, entsprechend der
        Meta-Datenverwendungsrichtlinie (
        <a
          href="https://de-de.facebook.com/about/privacy/"
          target="_blank"
          rel="noopener noreferrer"
        >
          https://de-de.facebook.com/about/privacy/
        </a>
        ) verwenden kann. Dadurch kann Meta das Schalten von Werbeanzeigen auf
        Seiten von Facebook oder Instagram und sonstigen Werbekan&auml;len
        erm&ouml;glichen. Diese Verwendung der Daten kann von uns als
        Seitenbetreiber nicht beeinflusst werden.
      </p>{" "}
      <p>
        Die Nutzung dieses Dienstes erfolgt auf Grundlage Ihrer Einwilligung
        nach Art. 6 Abs. 1 lit. a DSGVO und &sect; 25 Abs. 1 TDDDG. Die
        Einwilligung ist jederzeit widerrufbar.
      </p>{" "}
      <p>
        Soweit mit Hilfe des hier beschriebenen Tools personenbezogene Daten auf
        unserer Website erfasst und an Meta weitergeleitet werden, sind wir und
        die Meta Platforms Ireland Limited, 4 Grand Canal Square, Grand Canal
        Harbour, Dublin 2, Irland gemeinsam f&uuml;r diese Datenverarbeitung
        verantwortlich (Art. 26 DSGVO). Die gemeinsame Verantwortlichkeit
        beschr&auml;nkt sich dabei ausschlie&szlig;lich auf die Erfassung der
        Daten und deren Weitergabe an Meta. Die nach der Weiterleitung
        erfolgende Verarbeitung durch Meta ist nicht Teil der gemeinsamen
        Verantwortung. Die uns gemeinsam obliegenden Verpflichtungen wurden in
        einer Vereinbarung &uuml;ber gemeinsame Verarbeitung festgehalten. Den
        Wortlaut der Vereinbarung finden Sie unter:{" "}
        <a
          href="https://www.facebook.com/legal/controller_addendum"
          target="_blank"
          rel="noopener noreferrer"
        >
          https://www.facebook.com/legal/controller_addendum
        </a>
        . Laut dieser Vereinbarung sind wir f&uuml;r die Erteilung der
        Datenschutzinformationen beim Einsatz des Meta-Tools und f&uuml;r die
        datenschutzrechtlich sichere Implementierung des Tools auf unserer
        Website verantwortlich. F&uuml;r die Datensicherheit der Meta-Produkte
        ist Meta verantwortlich. Betroffenenrechte (z.&nbsp;B.
        Auskunftsersuchen) hinsichtlich der bei Facebook oder Instagram
        verarbeiteten Daten k&ouml;nnen Sie direkt bei Meta geltend machen. Wenn
        Sie die Betroffenenrechte bei uns geltend machen, sind wir verpflichtet,
        diese an Meta weiterzuleiten.
      </p>{" "}
      <p>
        Die Daten&uuml;bertragung in die USA wird auf die
        Standardvertragsklauseln der EU-Kommission gest&uuml;tzt. Details finden
        Sie hier:{" "}
        <a
          href="https://www.facebook.com/legal/EU_data_transfer_addendum"
          target="_blank"
          rel="noopener noreferrer"
        >
          https://www.facebook.com/legal/EU_data_transfer_addendum
        </a>{" "}
        und{" "}
        <a
          href="https://de-de.facebook.com/help/566994660333381"
          target="_blank"
          rel="noopener noreferrer"
        >
          https://de-de.facebook.com/help/566994660333381
        </a>
        .
      </p>{" "}
      <p>
        In den Datenschutzhinweisen von Meta finden Sie weitere Hinweise zum
        Schutz Ihrer Privatsph&auml;re:{" "}
        <a
          href="https://de-de.facebook.com/about/privacy/"
          target="_blank"
          rel="noopener noreferrer"
        >
          https://de-de.facebook.com/about/privacy/
        </a>
        .
      </p>{" "}
      <p>
        Sie k&ouml;nnen au&szlig;erdem die Remarketing-Funktion &bdquo;Custom
        Audiences&rdquo; im Bereich Einstellungen f&uuml;r Werbeanzeigen unter{" "}
        <a
          href="https://www.facebook.com/ads/preferences/?entry_product=ad_settings_screen"
          target="_blank"
          rel="noopener noreferrer"
        >
          https://www.facebook.com/ads/preferences/?entry_product=ad_settings_screen
        </a>{" "}
        deaktivieren. Dazu m&uuml;ssen Sie bei Facebook angemeldet sein.
      </p>{" "}
      <p>
        Wenn Sie kein Konto bei Facebook oder Instagram besitzen, k&ouml;nnen
        Sie nutzungsbasierte Werbung von Meta auf der Website der European
        Interactive Digital Advertising Alliance deaktivieren:{" "}
        <a
          href="http://www.youronlinechoices.com/de/praferenzmanagement/"
          target="_blank"
          rel="noopener noreferrer"
        >
          http://www.youronlinechoices.com/de/praferenzmanagement/
        </a>
        .
      </p>
      <p>
        Das Unternehmen verf&uuml;gt &uuml;ber eine Zertifizierung nach dem
        &bdquo;EU-US Data Privacy Framework&ldquo; (DPF). Der DPF ist ein
        &Uuml;bereinkommen zwischen der Europ&auml;ischen Union und den USA, der
        die Einhaltung europ&auml;ischer Datenschutzstandards bei
        Datenverarbeitungen in den USA gew&auml;hrleisten soll. Jedes nach dem
        DPF zertifizierte Unternehmen verpflichtet sich, diese
        Datenschutzstandards einzuhalten. Weitere Informationen hierzu erhalten
        Sie vom Anbieter unter folgendem Link:{" "}
        <a
          href="https://www.dataprivacyframework.gov/participant/4452"
          target="_blank"
          rel="noopener noreferrer"
        >
          https://www.dataprivacyframework.gov/participant/4452
        </a>
        .
      </p>
      <h3>Meta Conversion API</h3>{" "}
      <p>
        Wir haben die Meta Conversion API auf dieser Website eingebunden.
        Anbieter dieses Dienstes ist die Meta Platforms Ireland Limited, 4 Grand
        Canal Square, Dublin 2, Irland. Die erfassten Daten werden nach Aussage
        von Meta jedoch auch in die USA und in andere Drittl&auml;nder
        &uuml;bertragen.
      </p>{" "}
      <p>
        Die Meta Conversion API erm&ouml;glicht es uns, die Interaktionen des
        Websitebesuchers mit unserer Website zu erfassen und an Meta
        weiterzugeben, um die Werbeperformance bei Facebook und Instagram zu
        verbessern.
      </p>{" "}
      <p>
        Hierzu werden insbesondere Zeitpunkt des Aufrufes, die aufgerufene
        Webseite, Ihre IP-Adresse und Ihr User-Agent sowie ggf. weitere
        spezifische Daten (z.&nbsp;B. gekaufte Produkte, Wert des Warenkorbs und
        W&auml;hrung) erfasst. Eine vollst&auml;ndige &Uuml;bersicht &uuml;ber
        die erfassbaren Daten finden Sie hier:{" "}
        <a
          href="https://developers.facebook.com/docs/marketing-api/conversions-api/parameters"
          target="_blank"
          rel="noopener noreferrer"
        >
          https://developers.facebook.com/docs/marketing-api/conversions-api/parameters
        </a>
        .
      </p>{" "}
      <p>
        Die Nutzung dieses Dienstes erfolgt auf Grundlage Ihrer Einwilligung
        nach Art. 6 Abs. 1 lit. a DSGVO und &sect; 25 Abs. 1 TDDDG. Die
        Einwilligung ist jederzeit widerrufbar.
      </p>{" "}
      <p>
        Soweit mit Hilfe des hier beschriebenen Tools personenbezogene Daten auf
        unserer Website erfasst und an Meta weitergeleitet werden, sind wir und
        die Meta Platforms Ireland Limited, 4 Grand Canal Square, Grand Canal
        Harbour, Dublin 2, Irland gemeinsam f&uuml;r diese Datenverarbeitung
        verantwortlich (Art. 26 DSGVO). Die gemeinsame Verantwortlichkeit
        beschr&auml;nkt sich dabei ausschlie&szlig;lich auf die Erfassung der
        Daten und deren Weitergabe an Meta. Die nach der Weiterleitung
        erfolgende Verarbeitung durch Meta ist nicht Teil der gemeinsamen
        Verantwortung. Die uns gemeinsam obliegenden Verpflichtungen wurden in
        einer Vereinbarung &uuml;ber gemeinsame Verarbeitung festgehalten. Den
        Wortlaut der Vereinbarung finden Sie unter:{" "}
        <a
          href="https://www.facebook.com/legal/controller_addendum"
          target="_blank"
          rel="noopener noreferrer"
        >
          https://www.facebook.com/legal/controller_addendum
        </a>
        . Laut dieser Vereinbarung sind wir f&uuml;r die Erteilung der
        Datenschutzinformationen beim Einsatz des Meta-Tools und f&uuml;r die
        datenschutzrechtlich sichere Implementierung des Tools auf unserer
        Website verantwortlich. F&uuml;r die Datensicherheit der Meta-Produkte
        ist Meta verantwortlich. Betroffenenrechte (z.&nbsp;B.
        Auskunftsersuchen) hinsichtlich der bei Facebook oder Instagram
        verarbeiteten Daten k&ouml;nnen Sie direkt bei Meta geltend machen. Wenn
        Sie die Betroffenenrechte bei uns geltend machen, sind wir verpflichtet,
        diese an Meta weiterzuleiten.
      </p>{" "}
      <p>
        Die Daten&uuml;bertragung in die USA wird auf die
        Standardvertragsklauseln der EU-Kommission gest&uuml;tzt. Details finden
        Sie hier:{" "}
        <a
          href="https://www.facebook.com/legal/EU_data_transfer_addendum"
          target="_blank"
          rel="noopener noreferrer"
        >
          https://www.facebook.com/legal/EU_data_transfer_addendum
        </a>{" "}
        und{" "}
        <a
          href="https://de-de.facebook.com/help/566994660333381"
          target="_blank"
          rel="noopener noreferrer"
        >
          https://de-de.facebook.com/help/566994660333381
        </a>
        .
      </p>{" "}
      <p>
        In den Datenschutzhinweisen von Meta finden Sie weitere Hinweise zum
        Schutz Ihrer Privatsph&auml;re:{" "}
        <a
          href="https://de-de.facebook.com/about/privacy/"
          target="_blank"
          rel="noopener noreferrer"
        >
          https://de-de.facebook.com/about/privacy/
        </a>
        .
      </p>{" "}
      <p>
        Sie k&ouml;nnen au&szlig;erdem die Remarketing-Funktion &bdquo;Custom
        Audiences&rdquo; im Bereich Einstellungen f&uuml;r Werbeanzeigen unter{" "}
        <a
          href="https://www.facebook.com/ads/preferences/?entry_product=ad_settings_screen"
          target="_blank"
          rel="noopener noreferrer"
        >
          https://www.facebook.com/ads/preferences/?entry_product=ad_settings_screen
        </a>{" "}
        deaktivieren. Dazu m&uuml;ssen Sie bei Facebook angemeldet sein.
      </p>{" "}
      <p>
        Wenn Sie kein Konto bei Facebook oder Instagram besitzen, k&ouml;nnen
        Sie nutzungsbasierte Werbung von Meta auf der Website der European
        Interactive Digital Advertising Alliance deaktivieren:{" "}
        <a
          href="http://www.youronlinechoices.com/de/praferenzmanagement/"
          target="_blank"
          rel="noopener noreferrer"
        >
          http://www.youronlinechoices.com/de/praferenzmanagement/
        </a>
        .
      </p>
      <p>
        Das Unternehmen verf&uuml;gt &uuml;ber eine Zertifizierung nach dem
        &bdquo;EU-US Data Privacy Framework&ldquo; (DPF). Der DPF ist ein
        &Uuml;bereinkommen zwischen der Europ&auml;ischen Union und den USA, der
        die Einhaltung europ&auml;ischer Datenschutzstandards bei
        Datenverarbeitungen in den USA gew&auml;hrleisten soll. Jedes nach dem
        DPF zertifizierte Unternehmen verpflichtet sich, diese
        Datenschutzstandards einzuhalten. Weitere Informationen hierzu erhalten
        Sie vom Anbieter unter folgendem Link:{" "}
        <a
          href="https://www.dataprivacyframework.gov/participant/4452"
          target="_blank"
          rel="noopener noreferrer"
        >
          https://www.dataprivacyframework.gov/participant/4452
        </a>
        .
      </p>
      <h2>7. Newsletter</h2>
      <h3>Newsletter&shy;daten</h3>{" "}
      <p>
        Wenn Sie den auf der Website angebotenen Newsletter beziehen
        m&ouml;chten, ben&ouml;tigen wir von Ihnen eine E-Mail-Adresse sowie
        Informationen, welche uns die &Uuml;berpr&uuml;fung gestatten, dass Sie
        der Inhaber der angegebenen E-Mail-Adresse sind und mit dem Empfang des
        Newsletters einverstanden sind. Weitere Daten werden nicht bzw. nur auf
        freiwilliger Basis erhoben. Diese Daten verwenden wir
        ausschlie&szlig;lich f&uuml;r den Versand der angeforderten
        Informationen und geben diese nicht an Dritte weiter.
      </p>{" "}
      <p>
        Die Verarbeitung der in das Newsletteranmeldeformular eingegebenen Daten
        erfolgt ausschlie&szlig;lich auf Grundlage Ihrer Einwilligung (Art. 6
        Abs. 1 lit. a DSGVO). Die erteilte Einwilligung zur Speicherung der
        Daten, der E-Mail-Adresse sowie deren Nutzung zum Versand des
        Newsletters k&ouml;nnen Sie jederzeit widerrufen, etwa &uuml;ber den
        &bdquo;Austragen&ldquo;-Link im Newsletter. Die
        Rechtm&auml;&szlig;igkeit der bereits erfolgten
        Datenverarbeitungsvorg&auml;nge bleibt vom Widerruf unber&uuml;hrt.
      </p>{" "}
      <p>
        Die von Ihnen zum Zwecke des Newsletter-Bezugs bei uns hinterlegten
        Daten werden von uns bis zu Ihrer Austragung aus dem Newsletter bei uns
        bzw. dem Newsletterdiensteanbieter gespeichert und nach der Abbestellung
        des Newsletters oder nach Zweckfortfall aus der Newsletterverteilerliste
        gel&ouml;scht. Wir behalten uns vor, E-Mail-Adressen aus unserem
        Newsletterverteiler nach eigenem Ermessen im Rahmen unseres berechtigten
        Interesses nach Art. 6 Abs. 1 lit. f DSGVO zu l&ouml;schen oder zu
        sperren.
      </p>{" "}
      <p>
        Daten, die zu anderen Zwecken bei uns gespeichert wurden, bleiben
        hiervon unber&uuml;hrt.
      </p>{" "}
      <p>
        Nach Ihrer Austragung aus der Newsletterverteilerliste wird Ihre
        E-Mail-Adresse bei uns bzw. dem Newsletterdiensteanbieter ggf. in einer
        Blacklist gespeichert, sofern dies zur Verhinderung k&uuml;nftiger
        Mailings erforderlich ist. Die Daten aus der Blacklist werden nur
        f&uuml;r diesen Zweck verwendet und nicht mit anderen Daten
        zusammengef&uuml;hrt. Dies dient sowohl Ihrem Interesse als auch unserem
        Interesse an der Einhaltung der gesetzlichen Vorgaben beim Versand von
        Newslettern (berechtigtes Interesse im Sinne des Art. 6 Abs. 1 lit. f
        DSGVO). Die Speicherung in der Blacklist ist zeitlich nicht befristet.{" "}
        <strong>
          Sie k&ouml;nnen der Speicherung widersprechen, sofern Ihre Interessen
          unser berechtigtes Interesse &uuml;berwiegen.
        </strong>
      </p>
      <h2>8. Plugins und Tools</h2>
      <h3>Google Fonts</h3>{" "}
      <p>
        Diese Seite nutzt zur einheitlichen Darstellung von Schriftarten so
        genannte Google Fonts, die von Google bereitgestellt werden. Beim Aufruf
        einer Seite l&auml;dt Ihr Browser die ben&ouml;tigten Fonts in ihren
        Browsercache, um Texte und Schriftarten korrekt anzuzeigen.
      </p>{" "}
      <p>
        Zu diesem Zweck muss der von Ihnen verwendete Browser Verbindung zu den
        Servern von Google aufnehmen. Hierdurch erlangt Google Kenntnis
        dar&uuml;ber, dass &uuml;ber Ihre IP-Adresse diese Website aufgerufen
        wurde. Die Nutzung von Google Fonts erfolgt auf Grundlage von Art. 6
        Abs. 1 lit. f DSGVO. Der Websitebetreiber hat ein berechtigtes Interesse
        an der einheitlichen Darstellung des Schriftbildes auf seiner Website.
        Sofern eine entsprechende Einwilligung abgefragt wurde, erfolgt die
        Verarbeitung ausschlie&szlig;lich auf Grundlage von Art. 6 Abs. 1 lit. a
        DSGVO und &sect; 25 Abs. 1 TDDDG, soweit die Einwilligung die
        Speicherung von Cookies oder den Zugriff auf Informationen im
        Endger&auml;t des Nutzers (z.&nbsp;B. Device-Fingerprinting) im Sinne
        des TDDDG umfasst. Die Einwilligung ist jederzeit widerrufbar.
      </p>{" "}
      <p>
        Wenn Ihr Browser Google Fonts nicht unterst&uuml;tzt, wird eine
        Standardschrift von Ihrem Computer genutzt.
      </p>{" "}
      <p>
        Weitere Informationen zu Google Fonts finden Sie unter{" "}
        <a
          href="https://developers.google.com/fonts/faq"
          target="_blank"
          rel="noopener noreferrer"
        >
          https://developers.google.com/fonts/faq
        </a>{" "}
        und in der Datenschutzerkl&auml;rung von Google:{" "}
        <a
          href="https://policies.google.com/privacy?hl=de"
          target="_blank"
          rel="noopener noreferrer"
        >
          https://policies.google.com/privacy?hl=de
        </a>
        .
      </p>
      <p>
        Das Unternehmen verf&uuml;gt &uuml;ber eine Zertifizierung nach dem
        &bdquo;EU-US Data Privacy Framework&ldquo; (DPF). Der DPF ist ein
        &Uuml;bereinkommen zwischen der Europ&auml;ischen Union und den USA, der
        die Einhaltung europ&auml;ischer Datenschutzstandards bei
        Datenverarbeitungen in den USA gew&auml;hrleisten soll. Jedes nach dem
        DPF zertifizierte Unternehmen verpflichtet sich, diese
        Datenschutzstandards einzuhalten. Weitere Informationen hierzu erhalten
        Sie vom Anbieter unter folgendem Link:{" "}
        <a
          href="https://www.dataprivacyframework.gov/participant/5780"
          target="_blank"
          rel="noopener noreferrer"
        >
          https://www.dataprivacyframework.gov/participant/5780
        </a>
        .
      </p>
      <h3>OpenStreetMap</h3>{" "}
      <p>Wir nutzen den Kartendienst von OpenStreetMap (OSM).</p>{" "}
      <p>
        Wir binden das Kartenmaterial von OpenStreetMap auf dem Server der
        OpenStreetMap Foundation, St John&rsquo;s Innovation Centre, Cowley
        Road, Cambridge, CB4 0WS, Gro&szlig;britannien, ein.
        Gro&szlig;britannien gilt als datenschutzrechtlich sicherer Drittstaat.
        Das bedeutet, dass Gro&szlig;britannien ein Datenschutzniveau aufweist,
        das dem Datenschutzniveau in der Europ&auml;ischen Union entspricht. Bei
        der Nutzung der OpenStreetMap-Karten wird eine Verbindung zu den Servern
        der OpenStreetMap-Foundation hergestellt. Dabei k&ouml;nnen u.&nbsp;a.
        Ihre IP-Adresse und weitere Informationen &uuml;ber Ihr Verhalten auf
        dieser Website an die OSMF weitergeleitet werden. OpenStreetMap
        speichert hierzu unter Umst&auml;nden Cookies in Ihrem Browser oder
        setzt vergleichbare Wiedererkennungstechnologien ein.
      </p>
      <p>
        Die Nutzung von OpenStreetMap erfolgt im Interesse einer ansprechenden
        Darstellung unserer Online-Angebote und einer leichten Auffindbarkeit
        der von uns auf der Website angegebenen Orte. Dies stellt ein
        berechtigtes Interesse im Sinne von Art. 6 Abs. 1 lit. f DSGVO dar.
        Sofern eine entsprechende Einwilligung abgefragt wurde, erfolgt die
        Verarbeitung ausschlie&szlig;lich auf Grundlage von Art. 6 Abs. 1 lit. a
        DSGVO und &sect; 25 Abs. 1 TDDDG, soweit die Einwilligung die
        Speicherung von Cookies oder den Zugriff auf Informationen im
        Endger&auml;t des Nutzers (z.&nbsp;B. Device-Fingerprinting) im Sinne
        des TDDDG umfasst. Die Einwilligung ist jederzeit widerrufbar.
      </p>
    </div>
    </div>
    <Footer />
    </div>

  );
}
